import React from 'react';
import TopNavbar from '../../../home/TopNavbar';

const styles = `
    /* General body and container styling */
    

    .container {
        max-width: 1200px;
        margin: auto;
        background-color: #fff;
        padding: 10px;
        border-radius: 10px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
         padding-bottom: 100px;
          margin-top:30px;
    }

    /* Heading styles */
    .main-heading {
      padding-top:50px;
        color: #880e4f; /* Dark magenta */
        text-align: center;
        font-size: 1.5em;
        margin-bottom: 10px;
        border-bottom: 3px solid #880e4f;
        padding-bottom: 10px;
    }

    .sub-heading {
        color: #ad1457; /* Slightly lighter magenta */
        font-size: 2em;
        margin-top: 40px;
        margin-bottom: 15px;
    }

    .table-heading {
        color: #c2185b; /* Another shade of magenta */
        font-size: 1.5em;
        margin-top: 30px;
        margin-bottom: 10px;
    }

    .sub-table-heading {
        color: #d81b60; /* Lighter magenta */
        font-size: 1.2em;
        margin-top: 25px;
        margin-bottom: 10px;
        text-transform: uppercase;
    }

    /* Paragraph styles */
    .intro-paragraph, .section-paragraph {
        font-size: 1em;
        text-align: justify;
        margin-bottom: 20px;
    }

    /* Table styles */
    table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 20px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    th, td {
        padding: 12px;
        text-align: left;
        border: 1px solid #ddd;
    }

    thead th {
        background-color: #880e4f; /* Dark magenta for table headers */
        color: #fff;
        font-weight: bold;
        text-transform: uppercase;
    }

    /* Alternating row colors for better readability */
    tbody tr:nth-child(even) {
        background-color: #fce4ec; /* Light pink */
    }

    tbody tr:nth-child(odd) {
        background-color: #fff5f8; /* Even lighter pink */
    }

    /* Hover effect on table rows */
    tbody tr:hover {
        background-color: #f8bbd0; /* A slightly darker pink on hover */
        transition: background-color 0.3s ease;
    }

    /* Styling for the total row */
    tbody tr:last-child {
        font-weight: bold;
        background-color: #f48fb1 !important; /* A light, distinct pink for the total row */
    }

    tbody tr:last-child td {
        border-top: 2px solid #880e4f;
    }
`;

const ChemistryData = [
    { class: "11th", chapter: "Structure of Atom", questions: 2 },
    { class: "11th", chapter: "Classification of Elements and Periodicity in Properties", questions: 2 },
    { class: "11th", chapter: "Hydrocarbons", questions: 3 },
    { class: "11th", chapter: "Some Basic Concepts of Chemistry", questions: 2 },
    { class: "11th", chapter: "Redox Reactions", questions: 1 },
    { class: "11th", chapter: "Organic Chemistry: Some Basic Principles and Techniques", questions: 4 },
    { class: "11th", chapter: "Equilibrium", questions: 3 },
    { class: "11th", chapter: "Chemical Bonding and Molecular Structure", questions: 2 },
    { class: "11th", chapter: "Thermodynamics", questions: 1 },
    { class: "12th", chapter: "Biomolecules", questions: 2 },
    { class: "12th", chapter: "Principles of Qualitative Analysis", questions: 1 },
    { class: "12th", chapter: "Coordination Compounds", questions: 4 },
    { class: "12th", chapter: "The p-Block Elements (XII)", questions: 2 },
    { class: "12th", chapter: "Chemical Kinetics", questions: 3 },
    { class: "12th", chapter: "Electrochemistry", questions: 1 },
    { class: "12th", chapter: "Solutions", questions: 3 },
    { class: "12th", chapter: "Amines", questions: 2 },
    { class: "12th", chapter: "Aldehydes, Ketones and Carboxylic Acids", questions: 3 },
    { class: "12th", chapter: "The d and f-Block Elements", questions: 1 },
    { class: "12th", chapter: "Haloalkanes and Haloarenes", questions: 2 },
    { class: "12th", chapter: "Alcohols, Phenols and Ethers", questions: 1 },
];

const renderTable = (data) => (
    <table>
        <thead>
            <tr>
                <th>Class</th>
                <th>Chapter Name</th>
                <th>No. of Questions</th>
            </tr>
        </thead>
        <tbody>
            {data.map((item, index) => (
                <tr key={index}>
                    <td>{item.class}</td>
                    <td>{item.chapter}</td>
                    <td>{item.questions}</td>
                </tr>
            ))}
            <tr>
                <td colSpan="2"><strong>Total</strong></td>
                <td><strong>{data.reduce((sum, item) => sum + item.questions, 0)}</strong></td>
            </tr>
        </tbody>
    </table>
);

const NeetWeightageChemistry = () => {
    return (
        <div>
            <style>{styles}</style>
            <div className="container">
                 <TopNavbar name="Physics Weightage" />
                <h1 className="main-heading">Chemistry Chapter-wise Weightage in NEET 2025 Paper</h1>
                <p className="intro-paragraph">
                    The NEET 2025 Chemistry Chapter-wise Paper Analysis provides a structured breakdown of questions from Organic, Inorganic, and Physical Chemistry as featured in the NEET 2025 exam. It examines the frequency and difficulty level of each chapter, offering insight into which topics carried greater weight. This analysis helps aspirants focus their preparation on high-yield and conceptually challenging areas.
                </p>
                <h3 className="table-heading">Chapter Wise NEET Weightage for Chemistry</h3>
                {renderTable(ChemistryData)}
            </div>
        </div>
    );
};

export default NeetWeightageChemistry;